module.exports = __webpack_public_path__ + "static/fencing-0e08193f6993474e90812e270277cc84.jpg";